import { render, staticRenderFns } from "./detail-component-document-checklist.vue?vue&type=template&id=3e13ab85&scoped=true"
import script from "./detail-component-document-checklist.vue?vue&type=script&lang=ts"
export * from "./detail-component-document-checklist.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e13ab85",
  null
  
)

export default component.exports